import { render } from "./CreateRetailerOrder.vue?vue&type=template&id=7051a33a"
import script from "./CreateRetailerOrder.vue?vue&type=script&lang=js"
export * from "./CreateRetailerOrder.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__